import http from '@/http'

const PATH = '/tools/scheduled-reports/bundles'

export default {
    /**
     * @param {BundleQuery} data
     * @returns {Promise<void>}
     */
    async listScheduledBundles (params) {
        try {
            const response = await http.get(PATH, {params})
            return response.data.data
        } catch (e) {
            return Promise.reject(e)
        }
    }
}
